export const STAFF_USER_GROUP = 'staff';
export const ADMIN_USER_GROUP = 'admin';
export const APPLICANT_USER_GROUP = 'applicant';
